import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styles from '../../../SearchWidget.module.scss';
import {connect} from "react-redux";
import {setPromoCode} from "../../../../../services/flightCourse/actions";
import WindowEventWatcher from "../../../../Common/WindowEventWatcher";
import {refBlur, refFocus} from "../../../../../tools/tools";
import {withTranslation} from "react-i18next";
import shiftAware from "../../../../../hoc/ShiftAware/ShiftAware";
import animations from '../../../../../assets/scss/animations/animate.module.scss';


const PromoCode = ({prevRef, contRef, nextRef, promoCode, changeHandler, setPromoCode, disabled, t, shiftPressed, animated, isStudentOrResident, isStopoverSelected, ...props}) => {

    const [isFocused, setIsFocused] = useState(false);
    const [animationClasses, setAnimationClasses] = useState('');

    const isDisabled = disabled || isStudentOrResident || isStopoverSelected;
    const iconSign = <span className={promoCode ? 'icon-sata-delete-course' : 'icon-sata-add-course'} aria-hidden={true}/>;
    const onChangeHandler = isDisabled ? () => null : changeHandler;
    const inputRef = contRef ? contRef : React.createRef();
    const containerClasses = ['sw-hidden-on-shrink', styles.promoCodeContainer];
    if (isDisabled) containerClasses.push(styles.promoCodeDisabled);
    if (animated) containerClasses.push(animationClasses);

    const blurHandler = () => {
        setIsFocused(false);
        refBlur(contRef);
    };

    const focusHandler = () => {
        setIsFocused(true);
        setAnimationClasses(`${animations.animated} ${animations.touchEffect}`);
        setTimeout(() => setAnimationClasses(''), 500);

    };

    const keyDownHandler = e => {
        const code = e.code ? e.code : e.key;

        if (code === 'Tab' && shiftPressed) {
            blurHandler();
            refFocus(prevRef);
            e.stopPropagation();
            e.preventDefault();
            return;
        }

        switch (code) {
            case 'Left':
            case 'ArrowLeft':
                blurHandler();
                refFocus(prevRef);
                break;
            case 'NumpadEnter':
            case 'Enter':
            case 'Tab':
            case 'Right':
            case 'ArrowRight':
                blurHandler();
                refFocus(nextRef);
                break;
            case 'Escape':
                blurHandler();
                break;
            default:
                return;
        }

        e.preventDefault();
        e.stopPropagation();
    };

    const inputChangeHandler = e => {
        const {target} = e;
        const {value} = target;

        const isValid = /^[A-Za-z0-9]{0,6}$/g.test(value);
        if (isValid) {
            onChangeHandler(value);
        }
    };

    return (
        <div className={containerClasses.join(' ')}>
            <div className={styles.promoCodeBtn}
                 onClick={promoCode ? () => inputChangeHandler({target: {value: ''}}) : () => inputRef.current.focus()}>
                {iconSign}
            </div>
            <input ref={inputRef}
                   type='text'
                   name={'promo code'}
                   aria-label={'promo code'}
                   aria-required="true"
                   onChange={inputChangeHandler}
                   onFocus={focusHandler}
                   onBlur={blurHandler}
                   value={promoCode}
                   readOnly={isDisabled}
                   autoComplete={'off'}
                   className={styles.promoCode}
                   placeholder={t('Promo')}/>
            <WindowEventWatcher eventName='keydown' listening={isFocused} handlerFn={keyDownHandler}/>
        </div>
    );
};

PromoCode.propTypes = {
    disabled: PropTypes.bool,
    setPromoCode: PropTypes.func,
    changeHandler: PropTypes.func,
    isStudentOrResident: PropTypes.bool,
    isStopoverSelected: PropTypes.bool,
    promoCode: PropTypes.string,
    shiftPressed: PropTypes.bool,
    contRef: PropTypes.any,
    prevRef: PropTypes.any,
    nextRef: PropTypes.any,
    animated: PropTypes.bool,
    t: PropTypes.func,
};

PromoCode.defaultProps = {
    disabled: false,
    setPromoCode: () => null,
    changeHandler: () => null,
    isStudentOrResident: false,
    isStopoverSelected: false,
    promoCode: '',
    shiftPressed: false,
    contRef: null,
    prevRef: null,
    nextRef: null,
    animated: false,
    t: s => s,
};

export default connect(state => ({
    promoCode: state.flightCourse.promoCode,
    isStudentOrResident: state.flightCourse.passengerType !== 'ADULT',
    isStopoverSelected: Boolean(state.flightCourse.stopover.outgoing.selectedAirport || state.flightCourse.stopover.incoming.selectedAirport)
}), {changeHandler: setPromoCode})(withTranslation()(shiftAware(PromoCode)));
